import React, { useEffect, useState, useRef } from "react";
import Head from "next/head";
import { useDispatch, useSelector } from "react-redux";
import { mapMainMenuProps } from "@/components/DesignSystem/mappers/navigationV2Mapper";
import Script from "next/script";
import {
  formatPhoneNumber,
  getMyLocation,
  getPageLevelScriptsAndStyles,
  getRandom,
  getCityList,
  addMavenoidChat,
  removeMavenoidChat,
} from "@/utils/helper";
import {
  findItemByName,
  hasHeaderItems,
} from "@/components/DesignSystem/utils/navigationHelper";
import {
  selectGenericState,
  setToastContent,
  showPromoModal,
} from "@/store/features/genericSlice";
import MainMenu from "@/components/DesignSystem/Mainmenu";
import UtilityWidgets from "../UtilityWidgets/v1/UtilityWidgets";
import {
  getFavorites,
  getMyAccountListsWithLineItems,
  selectFavoritesState,
} from "@/store/features/favoritesSlice";
import useAuthUtilityNavi18n from "@/i18n/useAuthUtilityNavi18n";
import {
  logout,
  selectAuthState,
  setAuthModalVisibility,
} from "@/store/features/authSlice";
import { GLOBAL_CONFIGURATION_ENDPOINT,GEOLOCATION_ERROR_TITLE, } from "@/constants/index";
import { aemAxiosInstance } from "@/constants/api";
import { useRouter } from "next/router";
import { getCartCount } from "@/utils/cart";
import { getShortenedUrl } from "@/utils/location";
import { getConfig } from "@/constants/config";
import _get from "lodash/get";
import { headerFindStoreUseLocationAnalytics } from "@/components/FindStoreUtilNav/analytics";
import { getTranslations } from "@/components/FindStoreUtilNav/v1/localization";
import get from "lodash/get";
import { getUtilityStoreDetails } from "@/utils/location";
import { useTranslation } from "react-i18next";
import {
  locationState,
  setStoreAddress,
  setMyStore,
  setUtilityStoreDetails,
} from "@/store/features/locationSlice";
import { getFindAStoresResult } from "@/components/FindStore/v1/api";
import _isEmpty from "lodash/isEmpty";
import ZipCodeInfoModal from "@/components/core/Modal/ZipCodeInfoModal";
import useFindStorei18n from "@/i18n/useFindStorei18n";
import {
  dataLayerForSignOut,
  dataLayerForUtilityClicks,
  newdataLayerForCreateAccount,
  newdatalayerforSignIn,
} from "@/components/Shared/HeaderNavTabs/analytics/index";
import { isMobile } from "react-device-detect";
import useWindowResize from "@/hooks/useWindowResize";
import useFindashowroomi18n from "@/i18n/useFindashowroomi18n";
import { MY_LISTS_PAGE_PATH } from "../../../constants";

const configInitialState = {
  browseAllStoreUrl: "",
  brand: "",
  findStores: "",
};

const GlobalPageHeader = props => {
  const {
    header = {},
    templateName = "",
    themeType = "",
    title = "",
    description = "",
    globalScripting = "",
    isPdp = false,
    imageUrl = "",
    email = "",
    phone = "",
    fullUrl = "",
    siteName = "",
    breadCrumb=[]
  } = props;

  const {
    pageIsInteractive,
    featureFlags = {},
    globalConfig: {
      internationalization: { language = "en" } = {},
      general: {
        cartLandingPagePath = "",
        signInFragment = "",
        signUpFragment = "",
        navigationHoverTiming = "",
        siteName: BrandName = "",
      } = {},
    } = {},
  } = useSelector(selectGenericState);

  const { utilityStoreDetails, utilityData, myStoreId } = useSelector(locationState);

  const initialState = {
    userCity: "",
    utilityLocation: "",
    utilityData: {},
    utilityStoreDetails: {},
    findStores: "",
    reverseGeo: "",
    myStoreId: typeof Window !== "undefined" ? localStorage.getItem("myStoreId") : 0,
    siteName: "",
    findStoreUrl: "",
    utilityStoreDetailsUrl: "",
  };

  const { data: authorData = {} } = props;
  const staticTexts = useFindashowroomi18n({ authorData });

  const bodyRef = useRef(null);
  const htmlRef = useRef(null);

  const [metas, setMetas] = useState([]);
  const [styles, setStyles] = useState([]);
  const [scripts, setScripts] = useState([]);
  const [links, setLinks] = useState([]);
  const [logIndata, setLogIndata] = useState([]);
  const [logOutdata, setLogOutdata] = useState([]);
  const [favoritesPagePath, setFavoritesPagePath] = useState("/");
  const [favoritesPage, setFavoritesPage] = useState([]);
  const { MYSQLCONNSTR_ENABLE_SHOPPING_LISTS_V2: isSaveProductToList = false } = featureFlags;
  const { favorites = {}, saveToListLineItems = {} } = useSelector(selectFavoritesState);
  const { lineItems = [], textLineItems } = favorites || {};
  const i18n = useAuthUtilityNavi18n();
  const router = useRouter();
  const cartCount = getCartCount();
  const { user: { firstName = null } = {}, isAuth = false } = useSelector(selectAuthState);
  const { globalConfig } = useSelector(selectGenericState);
  const dispatch = useDispatch();

  const onclicksignIN = (datalayershow = true) => {
    dispatch(setAuthModalVisibility({ show: true }));
    if (datalayershow) {
      newdatalayerforSignIn();
    }
  };
  const onClickCreateAccount = () => {
    dispatch(setAuthModalVisibility({ show: true, active: 1 }));
    newdataLayerForCreateAccount();
  };
  const [loginFavouriteCallback, setLoginFavouriteCallback] = useState(null);
  const [myListsPagePath, setMyListsPagePath] = useState("/");
  const [configState, setConfigState] = useState(configInitialState);

  // for search panel
  const [showSearchBar, setShowSearchBar] = useState(false);
  const { t } = useTranslation("common");
  const staticText = getTranslations(t);
  const [state, setState] = useState(initialState);
  const [zipCodeValue, setZipcodeValue] = useState("");
  const [infoModalErrror, setInfoModalErrror] = useState({});
  const [infoModal, setInfoModal] = useState();
  const [browseAllStoreUrl, setbrowseAllStoreUrl] = useState("");
  const [myStoreUrl, setMyStoreUrl] = useState("/");
  const [optionList, setOptionList] = useState([]);
  const [canadaCheck, setCanadaCheck] = useState(false);

  useEffect(() => {
    if (state.utilityStoreDetailsUrl !== "") setUtilityStoreDetailsUrl();
  }, [state.utilityStoreDetailsUrl]);

  useEffect(() => {
    setInitalState();
    const toasterData = findItemByName(header, "toaster")|| {};
    if (!_isEmpty(toasterData)) dispatch(setToastContent({ ...toasterData }));
  }, []);

  const handleGlobalClick = e => {
    const target = e.target.closest('[data-datalayer-id="kds-element-navigation"]');
    if (target) {
      const rawEventInfo = JSON.parse(
        target?.attributes?.["data-datalayer-data"]?.nodeValue || "{}"
      );
      const page = window.pageObj || {};

      const commonEventInfo = {
        eventAction: rawEventInfo.eventAction || "main dropdown menu",
        eventType: rawEventInfo.eventType || "global header",
        eventName: rawEventInfo.eventName || "main dropdown menu",
        internalLinkPosition: rawEventInfo?.internalLinkPosition || "global header",
        internalLinkZoneName: rawEventInfo?.internalLinkZoneName || "global header",
        internalLinkType: rawEventInfo?.internalLinkType || "global header:navigation",
      };

      const getProductInfo = () => {
        if ((rawEventInfo.internalLinkPosition || "").includes("teaser")) {
          const productInfo = {
            productCategory: "n/a",
            productCollectionsName: "n/a",
            productRoom: "n/a",
          };
          return productInfo;
        }
      };
      const isproductInfo = getProductInfo();

      let eventInfo = {};
      eventInfo = {
        ...rawEventInfo,
        ...commonEventInfo,
      };

      if (isproductInfo) {
        window.adobeDataLayer.push({
          event: "cmp:click",
          page,
          eventInfo,
          productInfo: isproductInfo,
        });
      } else {
        window.adobeDataLayer.push({
          event: "cmp:click",
          page,
          eventInfo,
        });
      }
    }
  };
  useEffect(() => {
    document.addEventListener("click", handleGlobalClick);
    return () => document.removeEventListener("click", handleGlobalClick);
  }, []);

  const setInitalState = async () => {
    const config = await getConfig();
    getFindStoreUrl(config).then(url => {
      setState({
        ...state,
        findStores: get(config, "apiEndPointData.findStores", ""),
        reverseGeo: get(config, "apiEndPointData.reverseGeo", ""),
        siteName: get(config, "general.siteName", ""),
        cartLandingPagePath: get(config, "general.cartLandingPagePath", ""),
        signInFragment: get(config, "general.signInFragment", ""),
        signUpFragment: get(config, "general.signUpFragment", ""),
        siteName: get(config, "general.siteName", ""),
        utilityStoreDetailsUrl: get(config, "general.storeDetailsServletPath"),
        findStoreUrl: url,
      });
    });
  };
  const getFindStoreUrl = async config => {
    const findStoreUrl = await getShortenedUrl(get(config, "general.findStorePagePath", ""));
    return findStoreUrl;
  };

  const setUtilityStoreDetailsUrl = async () => {
    const utilityStoreDetails = await getUtilityStoreDetails(state);
    dispatch(setUtilityStoreDetails(utilityStoreDetails));
    setState({
      ...state,
      utilityStoreDetails,
    });
  };

  const redirect = zipCodeValue => {
    const asPath = `${state.findStoreUrl}?q=${zipCodeValue}`;
    window.location.href = asPath
  };
  const handleZipCodeUpdate = value => {
    setZipcodeValue(value);
  };

  const getGeoLocation = () => {
    getMyLocation()
      .then(getLocation => {
        setZipcodeValue(
          getLocation.zipcode ? Number(getLocation.zipcode) : undefined
        );
        headerFindStoreUseLocationAnalytics({ eventStatus: "success" });
      })
      .catch(({ cause }) => {
        setInfoModalErrror({
        title: cause?.title || GEOLOCATION_ERROR_TITLE,
        // message: GEOLOCATION_ERROR_TITLE,
        ctaLink: cause?.ctaLink,
        ctaLabel: cause?.ctaLabel,
      });
        setInfoModal(true);
        headerFindStoreUseLocationAnalytics({
          errorMessage: cause?.message ?? "",
          staticTexts,
          eventStatus: "failure",
        });
      });
  };

  useEffect(() => {
    getConfig()
      .then(async config => {
        if (config?.general) {
          const { general } = config || {};
          const url = await getShortenedUrl(general.allStoresPagePath ?? "/");
          const findStores = get(config, "apiEndPointData.findStores", "");
          const brand = get(config, "general.siteName", "");
          setConfigState({
            browseAllStoreUrl: url,
            findStores,
            brand,
          });
          localStorage.getItem("currentZipCode") &&
            setZipcodeValue(localStorage.getItem("currentZipCode"));
          setbrowseAllStoreUrl(url);
        }
      })
      .catch(err => console.log(err));
  }, []);

  useEffect(() => {
    if (myStoreId === 0) {
      nearestStoreAddress();
    } else {
      dispatch(setStoreAddress(utilityData));
    }
  }, [zipCodeValue, myStoreId]);

  useEffect(() => {
    if (zipCodeValue.length > 2) {
      fetchListOfCities();
    }
  }, [zipCodeValue]);

  const fetchListOfCities = async () => {
    const { findStores, brand } = configState;
    const responseData = await getCityList(findStores, brand, zipCodeValue);
    const { data: { d: { results = [] } = {} } = {} } = responseData;
    const cities = results.map(city => city.Locality);
    setOptionList([...new Set(cities)]);
  };

  const nearestStoreAddress = async () => {
    getConfig()
      .then(async config => {
        const findStores = get(config, "apiEndPointData.findStores", "");
        const brand = get(config, "general.siteName", "");
        if (!findStores || zipCodeValue?.length < 3) return;
        const nearestStore = await getFindAStoresResult(
          findStores,
          zipCodeValue,
          brand,
          100,
          1,
          "kohler store",
          1
        );
        if (nearestStore !== undefined) {
          const nearestStoreData = nearestStore?.data?.info[0] ?? {};
          const utilityData = {
            ...nearestStoreData,
            EntityID: nearestStoreData?.BPnumber ?? null,
          };
          dispatch(setStoreAddress(utilityData));
        } else {
          const utilityData = {};
          dispatch(setStoreAddress(utilityData));
        }
      })
      .catch(err => console.log(err));
  };

  useEffect(() => {
    if (!_isEmpty(utilityStoreDetails) && utilityData?.BPnumber) {
      getShortenedUrl(utilityStoreDetails[utilityData.BPnumber]).then(
        myStoreUrl => {
          setMyStoreUrl(myStoreUrl);
        }
      );
    }
  }, [utilityStoreDetails, utilityData]);

  const handleUtilityStoreCheck = entity => {
    localStorage.setItem("myStoreId", entity);
    dispatch(setMyStore(entity));
    setState({
      ...state,
      myStoreId: entity,
    });
      if (entity === 0) {
    dispatch(setStoreAddress({}));
  }
  };

  const pageUrl =
    fullUrl || (typeof window !== "undefined" ? window?.location?.href : "");

  useEffect(() => {
    const { pageLevelDetails = [] } =
      getPageLevelScriptsAndStyles(globalScripting);
    setMetas(pageLevelDetails["metaList"]);
    setStyles(pageLevelDetails["stylesList"]);
    setScripts(pageLevelDetails["pageScripts"]);
    setLinks(pageLevelDetails["linkList"]);
  }, [globalScripting]);

  useEffect(() => {
    if (typeof window !== "undefined") {
      bodyRef.current = document.body;
      htmlRef.current = document.getElementsByTagName("html")[0];
    }
  }, []);

  const handleSearchClick = () => {
    showSearchBar
      ? addMavenoidChat()
      : isMobile
        ? removeMavenoidChat()
        : addMavenoidChat();
    const classNames = ["searchbar-open", "scroll-lock"];
    classNames.forEach(className =>
      bodyRef?.current?.classList?.toggle(className)
    );
    classNames.forEach(className =>
      htmlRef?.current?.classList?.toggle(className)
    );
    setShowSearchBar(!showSearchBar);
    const page = window.pageObj || {};
    const previousPageNameForSearch = page?.pageInfo?.pageName;
    sessionStorage.setItem(
      "previousPageNameForSearch",
      previousPageNameForSearch
    );
  };

  useEffect(() => {
    if (isSaveProductToList) {
      setFavoritesPagePath(`/${language}${MY_LISTS_PAGE_PATH}`);
    } else {
      getConfig().then(async config => {
        const myFavPath = _get(config, "general.myFavoritesPagePath", "");
        setFavoritesPagePath(await getShortenedUrl(myFavPath ?? "/"));
      });
    }
  }, [isSaveProductToList]);

  useEffect(() => {
    if (isAuth) {
      dispatch(getFavorites())
        .unwrap()
        .then(rsp => {
          if (rsp && rsp !== null) {
            setFavoritesPage(rsp.lineItems);
          } else {
            setFavoritesPage([]);
          }
        });
    }
  }, [isAuth, isSaveProductToList]);

  useEffect(() => {
    if (favorites?.lineItems && favorites?.lineItems.length > 0) {
      setFavoritesPage(favorites?.lineItems);
    } else {
      setFavoritesPage([]);
    }
  }, [favorites]);

  useEffect(() => {
    if (Object.keys(saveToListLineItems).length && isAuth) {
      setFavoritesPage(Object.keys(saveToListLineItems));
    } else {
      setFavoritesPage([]);
    }
  }, [Object.keys(saveToListLineItems).length]);

  const onClickSignOut = () => {
    dispatch(logout());
    dataLayerForSignOut();
  };
  const setPromoModal = data => {
    dispatch(showPromoModal(data));
  };
  useEffect(() => {
    if (loginFavouriteCallback && isAuth) {
      window.loginFavouriteCallback = null;
      setLoginFavouriteCallback(null);
      window.location.href = myListsPagePath;
    }
  }, [loginFavouriteCallback, isAuth]);
  const getNavMobileData = async () => {
    if (state?.signInFragment) {
      const result = await aemAxiosInstance({
        url: `${GLOBAL_CONFIGURATION_ENDPOINT}?path=${state.signInFragment}`,
        method: "GET",
      });
      const logIndata = result.data.commonTopics;
      setLogIndata(logIndata);
    }
    if (state?.signUpFragment) {
      const signupdata = await aemAxiosInstance({
        url: `${GLOBAL_CONFIGURATION_ENDPOINT}?path=${state.signUpFragment}`,
        method: "GET",
      });
      const loggedOutData = signupdata.data.commonTopics;
      setLogOutdata(loggedOutData);
    }
  };

  const favClickHandler = (e, path = "") => {
    dataLayerForUtilityClicks("favorites", false, favoritesPagePath);
    if (!isAuth) {
      window.loginFavouriteCallback = () => {
        setLoginFavouriteCallback(e);
      };
      if (path) setMyListsPagePath(path);
      onclicksignIN(false);
      e.stopPropagation();
      e.preventDefault();
    } else if (path && isAuth) {
      router.push(path);
    }
  };

  const fragmentList = globalConfig?.contentFragmentListConfig || {};

  useEffect(() => {
     getNavMobileData();
  }, [state]);

  const [width] = useWindowResize();

  const navigationProps = mapMainMenuProps(
    header,
    // mockNavigationData,// Use mockNavigationData for navigationProps
    i18n,
    lineItems,
    textLineItems,
    firstName,
    isAuth,
    logIndata,
    logOutdata,
    onclicksignIN,
    onClickCreateAccount,
    onClickSignOut,
    favClickHandler,
    cartCount,
    themeType?.includes("light") ? "light" : "dark",
    handleSearchClick,
    !themeType?.includes("transparent"),
    favoritesPage,
    favoritesPagePath,
    state.cartLandingPagePath,
    router.asPath,
    setPromoModal,
    canadaCheck,
    navigationHoverTiming,
    staticTexts.searchHeader,
    language,
    isSaveProductToList,
    width
  );

  const getStoreAnalytics = action => {
    const href =
      utilityStoreDetails && utilityStoreDetails[utilityData?.BPnumber]
        ? utilityStoreDetails[utilityData?.BPnumber]
        : "/";
    const internalLinkName =
      action === "unset as my store"
        ? "unset as preferred store"
        : "store details";
    return JSON.stringify({
      eventAction: "find a store:utility nav:" + action,
      eventName: "find a store:utility nav:" + action,
      eventType: "navigation",
      eventMsg: "n/a",
      eventStatus: "n/a",
      internalLinkName,
      internalLinkPosition: "find a store",
      internalLinkType:
        "find a store:" +
        (
          utilityData?.LocationName +
          ", " +
          utilityData?.AddressLine +
          (!_isEmpty(utilityData?.AddressLine2)
            ? ", " + utilityData?.AddressLine2
            : "") +
          ", " +
          formatPhoneNumber(utilityData?.Phone)
        )?.toLowerCase(),
      internalLinkZoneName: "find a store:utility nav",
      internalLinkURL:
        typeof window !== "undefined"
          ? action === "view store details"
            ? href.indexOf("http") === -1
              ? window.location.origin + href
              : href
            : "n/a"
          : "n/a",
      clickInternalLinks: "true",
    });
  };

  const viewStoreAnalytics = getStoreAnalytics("view store details");
  const unsetMyStoreAnalytics = getStoreAnalytics("unset as my store");

  const storeMenu = {
    mod: "charcoal",
    eyebrow: {
      text: (
        <div>
          {" "}
          {!_isEmpty(utilityData && utilityData?.EntityID)
            ? myStoreId !== 0
              ? staticTexts?.myStore
              : staticTexts?.closestStore
            : ""}{" "}
        </div>
      ),
    },
    heading: {
      text: (
        <div>
          {" "}
          {!_isEmpty(utilityData && utilityData?.EntityID)
            ? utilityData?.LocationName
            : staticTexts?.locationDescription}{" "}
        </div>
      ),
    },
    subheading: {
      text: (
        <div>
          {" "}
          {!_isEmpty(utilityData && utilityData?.EntityID)
            ? ""
            : staticTexts?.zipCodeContent}{" "}
        </div>
      ),
    },
    storeInfo: !_isEmpty(utilityData && utilityData?.EntityID) ? (
      <div>
        <p>{utilityData?.OpenUntil}</p>
        <p>
          <span>{utilityData?.AddressLine}</span>
          {!_isEmpty(utilityData?.AddressLine2) ? (
            <span>{utilityData?.AddressLine2}</span>
          ) : (
            ""
          )}
          <br />
          <span>
            {utilityData?.Locality +
              ", " +
              utilityData?.AdminDistrict +
              " " +
              utilityData?.PostalCode}
          </span>
        </p>
        <p>{formatPhoneNumber(utilityData?.Phone)}</p>
        {myStoreUrl && (
          <a
            className="store-a"
            href={myStoreUrl}
            data-datalayer-id="kds-element-navigation"
            data-datalayer-data={viewStoreAnalytics}
          >
            {staticTexts?.storeDetail}
          </a>
        )}
      </div>
    ) : undefined,
    setStoreCTA: {
      label: (
        <div className="myStoreLabel">
          {" "}
          {!_isEmpty(utilityData && utilityData?.EntityID)
            ? myStoreId === utilityData?.EntityID
              ? staticTexts?.myStore
              : staticTexts?.setAsMyStore
            : ""}{" "}
        </div>
      ),
      onChange: e => (
        <div>
          {" "}
          {!_isEmpty(utilityData && utilityData?.EntityID)
            ? handleUtilityStoreCheck(
              e.target.checked ? utilityData?.EntityID : 0
            )
            : ""}{" "}
        </div>
      ),
      checked: myStoreId === utilityData?.EntityID,
      "data-datalayer-id": "kds-element-navigation",
      "data-datalayer-data": unsetMyStoreAnalytics,
    },
    zipCodeInput: {
      eyebrow: !_isEmpty(utilityData && utilityData?.EntityID)
        ? { text: staticTexts?.NotYourStore + "?" }
        : undefined,
      optionList: optionList,
      label: staticTexts?.enterCityStateZip,
      inputValue: zipCodeValue,
      onInputChange: e => {
        handleZipCodeUpdate(e.target.value);
      },
      handleSubmit: zipCode => {
        redirect(zipCode);
      },
      CTA: {
        text: staticTexts?.submit,
        trackingAttributes: {
          "data-datalayer-id": "kds-element-navigation",
          "data-datalayer-data": JSON.stringify({
            eventAction: "find a store:utility nav:submit",
            eventName: "find a store:utility nav:submit",
            eventType: "navigation",
            eventMsg: "n/a",
            eventStatus: "success",
            internalLinkName: "submit",
            internalLinkPosition: "find a store",
            internalLinkType: `find a store:${zipCodeValue ?? ""}`,
            internalLinkZoneName: "find a store:utility nav",
            internalLinkURL: "n/a",
            clickInternalLinks: "true",
          }),
        },
      },
    },
    CTAs: [
      {
        text: staticTexts?.userMyLocation,
        onClick: () => {
          getGeoLocation();
        },
        component: "button",
      },
      {
        text: staticTexts?.viewAllStore,
        href: browseAllStoreUrl,
        trackingAttributes: {
          "data-datalayer-id": "kds-element-navigation",
          "data-datalayer-data": JSON.stringify({
            eventAction: "find a store:utility nav:view all stores",
            eventName: "find a store:utility nav:view all stores",
            eventType: "navigation",
            eventMsg: "n/a",
            eventStatus: "n/a",
            internalLinkName: "view all stores",
            internalLinkPosition: "global header:find a store",
            internalLinkType: "find a store:navigation",
            internalLinkZoneName: "find a store:utility nav",
            internalLinkURL:
              typeof window !== "undefined"
                ? `${window.location.origin}${browseAllStoreUrl}`
                : "n/a",
            clickInternalLinks: "true",
          }),
        },
        component: "a",
      },
    ],
    infoModal,
    infoModalErrror,
    setInfoModal,
    staticTexts,
  };

  useEffect(() => {
    const observer = new MutationObserver(() => {
      document.querySelectorAll(".kohler-main-menu-root").forEach(root => {
        root.querySelectorAll("button").forEach(btn => {
          btn.classList.add("af-icon-button");
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    return () => observer.disconnect();
  }, []);
  return (
    <>
      <Head>
        <title>{title}</title>
        {description ? <meta name="description" content={description} /> : null}
        {title ? <meta property="og:title" content={title} /> : null}
        {description ? (
          <meta property="og:description" content={description} />
        ) : null}
        {templateName ? (
          <meta property="og:type" content={templateName} />
        ) : null}
        {metas?.map((meta, i) => {
          if (meta.name && meta.content)
            return (
              <meta key={`meta-${i}`} name={meta.name} content={meta.content} />
            )
        })}
        {styles?.map((style, i) => {
          if (typeof style === "string")
            return (
              <React.Fragment key={`pagestyle-${i}`}>
                <style jsx global>
                  {style}
                </style>
              </React.Fragment>
            )
        })}
        {links?.map((link, i) => {
          if (typeof link !== "string")
            return (
              <link key={`pageLinks-${i}`} rel={link.rel} href={link.href} />
            )
        })}
        {breadCrumb?.length > 0 ? (
          <script
            key="structured-data-breadcrumb"
            type="application/breadcrumb+json"
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(JSON.stringify(breadCrumb)),
            }}
          />
        ): null}
      </Head>
      {pageIsInteractive &&
        scripts?.map((script, i) => {
          if (script.src)
            return (
              <Script
                key={`headscript-${i}`}
                src={script.src}
                type={script.type}
                integrity={script.integrity}
                id={`headscript-${i}`}
              />
            )
          if (!script.src && script.innerHTML)
            return (
              <Script key={`headscript-${i}`} id={`headscript-${i}`}>
                {`${script.innerHTML}`}
              </Script>
            )

        })}
      <MainMenu {...navigationProps} storeMenu={storeMenu} />
    </>
  );
};

export default GlobalPageHeader;